"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubstepBody = exports.StyledSubstepLabel = exports.StyledSubstepNumber = exports.StyledSubstepLine = exports.StyledNumber = exports.StyledSubstepCheckIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const GettingStartedLabel_1 = require("./types/GettingStartedLabel");
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const StackView_1 = require("../../../StackView");
const LABEL_TYPE = {
    [GettingStartedLabel_1.GETTING_STARTED_LABEL.todo]: {
        text: 'To do',
        color: '#e7585a'
    },
    [GettingStartedLabel_1.GETTING_STARTED_LABEL.recommended]: {
        text: 'Recommended',
        color: '#e0a938'
    }
};
exports.StyledSubstepCheckIcon = (0, styled_components_1.default)(Icon_1.Icon) ``;
exports.StyledNumber = styled_components_1.default.div `
    box-sizing: content-box;
    align-items: center;
    display: flex;
    height: 20px;
    width: 20px;
    justify-content: center;
    border-radius: 12px;

    ${exports.StyledSubstepCheckIcon} {
        width: 10px;
        height: 10px;
        min-width: 10px;
        min-height: 10px;
    }
`;
exports.StyledSubstepLine = styled_components_1.default.div `
    flex: 1;
    width: ${helpers_1.SPACING_XXS};
`;
exports.StyledSubstepNumber = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    top: 12px;
    width: ${helpers_1.SPACING_XXXL};
`;
exports.StyledSubstepLabel = styled_components_1.default.div.attrs(({ type }) => ({
    children: LABEL_TYPE[type].text
})) `
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    height: ${helpers_1.SPACING_M};
    padding: 0 ${helpers_1.SPACING_XS};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_S};
    color: white;

    background-color: ${({ type }) => LABEL_TYPE[type].color};

    &::before {
        content: '';
        position: absolute;
        left: 100%;
        top: 0;
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: ${helpers_1.SPACING_S} 0 0 ${helpers_1.SPACING_S};
        border-color: transparent transparent transparent ${({ type }) => LABEL_TYPE[type].color};
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 100%;
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: ${helpers_1.SPACING_S} ${helpers_1.SPACING_S} 0 0;
        border-color: ${({ type }) => LABEL_TYPE[type].color} transparent transparent transparent;
    }
`;
exports.StyledSubstepBody = (0, styled_components_1.default)(StackView_1.StackView) `
    display: block;
    flex: 1;
    outline: none;
    padding: ${helpers_1.SPACING_M} ${helpers_1.SPACING_S};
    text-decoration: none;

    ${({ isInteractable, isDisable, theme }) => isInteractable &&
    (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorHighlightLight};
                cursor: pointer;

                ${isDisable &&
        (0, styled_components_1.css) `
                    background-color: transparent;
                    cursor: default;
                    pointer-events: none;
                `}
            }

            &:focus,
            &:focus-within {
                background-color: ${theme.colorHighlightDark};
                cursor: pointer;

                ${isDisable &&
        (0, styled_components_1.css) `
                    background-color: transparent;
                    cursor: default;
                    pointer-events: none;
                `}
            }
        `}

    ${({ isDisable, theme }) => (0, styled_components_1.css) `
        a {
            outline: none;

            ${isDisable &&
    (0, styled_components_1.css) `
                color: ${theme.colorTextLight};
                pointer-events: none;
            `}

            &:focus, &:hover {
                text-decoration: none;
            }
        }
    `}
`;
//# sourceMappingURL=Substep.styles.js.map